// extracted by mini-css-extract-plugin
export default {"landingPageForm":"w7AR0LPStkCSQGHYj0Yg","dark":"JwvdVGtQyABMT6BcWhRT"};